<template>
  <div>
    <div :class="{ 'row justify-content-center': fromView !== 'add_invoice' }">
      <div :class="{ 'col-12': fromView !== 'add_invoice' }">
        <div :class="{ 'card card-general': fromView !== 'add_invoice' }">
          <div
            :class="{
              'card-body p-3': fromView !== 'add_invoice',
              'p-5': fromView == 'add_invoice',
            }"
          >

            <form class="form-v2 base-form-client h-100 d-flex flex-column justify-content-between">
              <div class="w-100">
                <div class="row gap-4 justify-content-center" style="margin-top: 25px; margin-bottom: 25px;">
                  <div class="form-check form-switch w-auto">
                    <input
                      class="form-check-input parts"
                      type="radio"
                      id="parts"
                      value="parts"
                      v-model="item_form.service_type"
                    />
                    <label
                      class="form-check-label"
                      :for="item_form.service_type === 'parts' ? 'parts' : 'services'"
                      >Parts</label>
                  </div>
                  <div class="form-check form-switch w-auto">
                    <input
                      class="form-check-input services"
                      type="radio"
                      id="services"
                      value="service"
                      v-model="item_form.service_type"
                    />
                    <label
                      class="form-check-label"
                      :for="item_form.service_type === 'services' ? 'services' : 'parts'"
                      >Services</label>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="input-group p-0">
                    <div class="input-group-text">
                      <img src="@/assets/images/system/network_laurenGreen.png" />
                    </div>
                    <select
                      name="catName"
                      class="form-select"
                      v-model="item_form.category_id"
                    >
                      <option value="" disabled selected="selected">
                        Select Category (default)*
                      </option>
                      <option
                        v-for="itemCat in categoryOptions"
                        :key="itemCat.id"
                        :value="itemCat.id"
                      >
                        {{ itemCat.type }}
                      </option>
                    </select>
                    <div class="input-group-text transparent p-0 append">
                      <button
                        type="button"
                        name="btn"
                        class="btn btn-lauren-green _sm"
                        @click="dialogVisibleCategoryPopup = true"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="input-group p-0">
                    <div class="input-group-text">
                      <img src="@/assets/images/system/tools_lauren-green.svg" />
                    </div>
                    <input
                      type="text"
                      name="itemTitle"
                      class="form-control"
                      v-model="item_form.name"
                      placeholder="Type item name or title*"
                    />
                    <div class="input-group-text transparent p-0 append">
                      <button
                        type="button"
                        name="btn"
                        class="btn btn-white _sm"
                        @click="$emit('show-list-of-items')"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <textarea
                    class="form-control"
                    v-model="item_form.description"
                    placeholder="Parts or Services description"
                  ></textarea>
                </div>
              </div>

              <div class="w-100">
                <div class="row m-0 mb-4 d-flex justify-content-end amount-fields">
                  <div class="col-sm-9">
                    <div class="row mb-4">
                      <div class="input-group group-half p-0">
                        <div class="input-group-text bg-light-orange no-after">
                          Quantity
                        </div>
                        <div class="form-floating">
                          <label class="floating-label _sm _end">(default=1)</label>
                          <input
                            type="number"
                            class="form-control text-right"
                            @keyup="calculateAmount"
                            v-model.number="item_form.quantity"
                            min="1"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row mb-4">
                      <div class="input-group group-half p-0">
                        <div class="input-group-text bg-light-sky no-after">Rate</div>
                        <div class="form-floating">
                          <label class="floating-label">{{currency_symbol}}</label>
                          <input
                            type="number"
                            class="form-control text-right"
                            v-model.number="item_form.unit_price"
                            @keyup="calculateAmount"
                            step="0.01"
                            min="0.00"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="input-group group-half p-0">
                        <div class="input-group-text bg-orange no-after">Amount</div>
                        <div class="form-floating">
                          <label class="floating-label">{{currency_symbol}}</label>
                          <input
                            type="number"
                            class="form-control text-right"
                            v-model.number="item_form.amount"
                            step="0.01"
                            min="0.00"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="card-footer">
            <div class="mt-4 mb-4 me-4 d-flex justify-content-end">
                <div class="cmn-aw p-0">
                  <button
                    type="submit"
                    name="save"
                    class="btn btn-success btn-big _3d-input"
                    @click="createItem"
                  >
                    Save
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog v-model="dialogVisibleCategoryPopup" width="40%" class="category-dialog" destroy-on-close>
      <template #header>
        <button class="btn btn-lauren-green btn-sm" style="margin-left: 65px;"><img src="@/assets/images/system/network-group-white.png" style="width: .70rem;" /> Add Category </button>
      </template>
      <AddCategory @categories-updated="onCategoriesUpdated"></AddCategory>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisibleCategoryPopup = false">Close</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import AddCategory from "./Category.vue";

export default {
  name: "AddItem",
  components: { AddCategory },
  props: ["fromView"],
  data() {
    return {
      item_form: {
        service_type: "parts",
        name: "",
        description: "",
        quantity: 1,
        unit_price: (0).toFixed(2),
        amount: (0).toFixed(2),
        item_no: "",
        category_id: "",
      },
      currency_symbol: this.$auth.user?.currency,
      category: "",
      dialogVisibleCategoryPopup: false,
    };
  },
  created() {
    this.generateInvoiceNumber();
    this.fetchCategory();
    this.$store.commit('item/clearToRecentItems');
  },
  watch: {
    dialogVisibleCategoryPopup(val, oldVal) {
      if (oldVal && !val) {
        const storeCats = this.$store.state.item?.item_category;
        if (Array.isArray(storeCats) && storeCats.length) {
          this.onCategoriesUpdated(storeCats);
        }
      }
    },
  },
  computed: {
    categoryOptions() {
      if (this.category) {
        return this.category.map((v) => {
          return {
            id: v.id,
            type: v.type,
          };
        });
      }
      return [];
    },
  },
  methods: {
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    calculateAmount() {
      this.item_form.amount = parseFloat(
        (this.item_form.quantity * this.item_form.unit_price).toFixed(2)
      );
    },
    generateInvoiceNumber() {
      this.showLoading();
      if (localStorage.getItem("item_number_generated")) {
        this.item_form.item_no = localStorage.getItem("item_number_generated");
        this.hideLoading();
        return false;
      }
      this.$store
        .dispatch("item/generateItemNumber", this.form)
        .then(() => {
          this.item_form.item_no = localStorage.getItem("item_number_generated");
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    createItem() {
      this.showLoading();
      this.$store
        .dispatch("item/createItem", this.item_form)
        .then(() => {
          this.$store.dispatch("item/getList", this.item_form.item_no);

          localStorage.removeItem("item_number_generated");
          this.$toast.success("Item created successfully.");
          this.resetForm();
          this.generateInvoiceNumber();
          if (this.fromView == "add_invoice") {
            this.$store.dispatch("item/getList", this.item_form.item_no).then(() => {
              this.$store.commit(
                "item/item_recently_added_items_invoice",
                this.item_form.item_no
              );
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    resetForm() {
      this.item_form = {
        service_type: "parts",
        name: "",
        description: "",
        quantity: 1,
        unit_price: 0,
        amount: 0,
        item_no: "",
        category_id: "",
      };
    },
    onCategoriesUpdated(categories) {
      this.category = categories;
    },
    fetchCategory() {
      this.$store
        .dispatch("item/fetchCategory", this.item_form)
        .then((res) => {
          this.category = res;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {});
    },
    setAddedItemNumber() {
      this.listAddedItemNumber =
        JSON.parse(localStorage.getItem("item_recently_added_items")) || [];
    },
  },
};
</script>
